<top-nav></top-nav>
<section class="main-container" *ngIf="!isCustomer">
    <breadcrumb-cmp [breadCrumbValue]="breadCrumbValue" [modifyFilter]="modifyFilter"></breadcrumb-cmp>
    <router-outlet></router-outlet>
</section>
<section class="main-container-customer" *ngIf="isCustomer">
    <router-outlet></router-outlet>
</section>